import React, { useEffect, useState } from "react";
import PdfViewer from "./PdfViewer";
import RawLog from "./RawLog";
import ErrorLog from "./ErrorLog";
import "../components/RightPanel.css";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/theme-xcode";
import "ace-builds/src-noconflict/ext-language_tools";
import Corrections from "./Corrections";
import Query from "./Query";
import { Box, HStack, IconButton, Tooltip } from "@chakra-ui/react";
import styles from "./PdfViewer.module.css";
import { useNavigate } from "react-router-dom";
import { Resize1, Resize2 } from "./icons";

// import {
//   AiFillCaretLeft,
//   AiOutlineArrowRight,
//   AiOutlineZoomIn,
//   AiOutlineZoomOut,
// } from "react-icons/ai";
// import { Button } from "@chakra-ui/react";

function RightPanel(props) {
  const [render, setRender] = useState(false);
  const navigate = useNavigate();
  // console.log(props);


  useEffect(() => {
    if (props.view === "pdf" || props.view === "proofPdf") {
      setRender(true);

    } else {
      setRender(false);
    }
  }, [props.view]);

  // console.log(props.errorData);

  // console.log(props.view);



  return (
    <div style={{ width: "100%" }}>
      {render ? (
        <PdfViewer
          pdfContainer={props.pdfContainer}
          key={props.test}
          prevScroll={props.prevScroll}
          data={props.view === "pdf" ? props.pdfData : props.proofPdfData}
          pdfFull={props.pdfFull}
          toggleEditor={props.toggleEditor}
          test={props.test}
          scrollPos={props.scrollPos}
        />

      ) : (
        <></>
      )}
      {props.view === "xml" ?
        <>
          <div className={styles.header}>
            <HStack
              backgroundColor="#454443"
              justifyContent="space-between"
              h="48px"
              width="auto"
              zIndex={10}
            >
              <Box marginLeft={"auto"}>
                {props.pdfFull ? (
                  <Tooltip label="Minimize PDF">
                    <IconButton
                      onClick={() => {
                        props.toggleEditor();
                      }}
                      size="lg"
                      bg="#454443"
                      aria-label="Resize pdf"
                      icon={<Resize2 />}
                      _hover={{ bg: "#222" }}
                    ></IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip label="Maximize PDF">
                    <IconButton
                      onClick={() => {
                        props.toggleEditor();
                        // setClientWidth(1);
                      }}
                      size="lg"
                      colorScheme="#f47c0d"
                      aria-label="Resize pdf"
                      icon={<Resize1 />}
                      bg="#454443"
                      _hover={{ bg: "#222" }}
                    ></IconButton>
                  </Tooltip>

                )}
              </Box>
            </HStack>
          </div>
          <div className={styles.xmleditor}>
            <AceEditor
              mode="xml"
              theme="xcode"
              name="test"
              fontSize={18}
              value={props.xml}
              width="95%"
              height="calc(90vh - 48px)"
              readOnly={true}
            /></div></> : <></>}
      {/* {props.view === "error" ? (
        <ErrorLog ace={props.editorRef} data={props.errorData} key="error" />
      ) : (
        <></>
      )} */}
      {props.view === "raw" ? <RawLog key="raw" data={props.rawData} pdfFull={props.pdfFull} toggleEditor={props.toggleEditor} /> : <></>}
      {/* {props.view === "correction" ? <Corrections ace={props.editorRef} /> : <></>}
      {props.view === "queries" ? <Query ace={props.editorRef} /> : <></>} */}
    </div>
  );
}

export default RightPanel;
